import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAuth } from '../contexts/AuthContext';
import { addProduct, updateProduct, removeProduct, addToCart, removeFromCart } from '../store/productsSlice';

const ProductManager = () => {
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [editingId, setEditingId] = useState(null);
  
  const { products, cart } = useSelector(state => state.products);
  const { userRole, isLoggedIn } = useAuth();
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !price) return;

    const productData = { name, price: parseFloat(price) };
    
    if (editingId) {
      dispatch(updateProduct({ ...productData, id: editingId }));
      setEditingId(null);
    } else {
      dispatch(addProduct(productData));
    }
    
    setName('');
    setPrice('');
  };

  const handleEdit = (product) => {
    setName(product.name);
    setPrice(product.price);
    setEditingId(product.id);
  };

  if (!isLoggedIn) {
    return <p>Please login to view products</p>;
  }

  return (
    <div>
      <h2>Products</h2>
      
      {userRole === 'admin' && (
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Product name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="number"
            placeholder="Price in ₹"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
          <button type="submit">
            {editingId ? 'Update' : 'Add'} Product
          </button>
        </form>
      )}

      <div>
        {products.map(product => (
          <div key={product.id} style={{ border: '1px solid #ccc', margin: '10px', padding: '10px' }}>
            <h3>{product.name}</h3>
            <p>₹{product.price}</p>
            <button onClick={() => dispatch(addToCart(product))}>
              Add to Cart
            </button>
            {userRole === 'admin' && (
              <>
                <button onClick={() => handleEdit(product)}>Edit</button>
                <button onClick={() => dispatch(removeProduct(product.id))}>
                  Delete
                </button>
              </>
            )}
          </div>
        ))}
      </div>

      <h3>Cart ({cart.length} items)</h3>
      {cart.map(item => (
        <div key={item.id} style={{ border: '1px solid #ddd', margin: '5px', padding: '5px' }}>
          <span>{item.name} x{item.quantity} - ₹{item.price * item.quantity}</span>
          <button onClick={() => dispatch(removeFromCart(item.id))}>Remove</button>
        </div>
      ))}
    </div>
  );
};

export default ProductManager;